import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitovapicab() {



    const cardData = {

keyword: "Mumbai to Vapi Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Vapi Cab services for business travelers, industrial visits, corporate clients, families, tourists, and outstation passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional chauffeurs for a smooth interstate journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel schedules, corporate travel solutions, 24/7 customer support, and transparent pricing, we ensure a hassle-free and comfortable journey to Vapi, one of Gujarat's leading industrial cities known for its business hubs, nearby beaches, gardens, heritage sites, and convenient access to popular tourist destinations in South Gujarat.",

topPlaces: [
    {
        title: "Daman",
        description:
            "Daman is one of the most popular destinations near Vapi and is known for its beautiful beaches, Portuguese heritage, historic forts, churches, and coastal charm. Visitors can explore Devka Beach, Jampore Beach, Moti Daman Fort, and colonial-era landmarks while enjoying the relaxing atmosphere of the Arabian Sea coastline. Its proximity to Vapi makes it a favorite weekend getaway for both tourists and business travelers."
    },
    {
        title: "Jampore Beach",
        description:
            "Jampore Beach is a peaceful and scenic beach located near Vapi and Daman, offering soft sand, calm waters, and a family-friendly environment. Visitors enjoy beach walks, horse rides, local food stalls, and stunning sunset views. The tranquil atmosphere makes it an ideal destination for relaxation after a busy work schedule or long journey."
    },
    {
        title: "Devka Beach",
        description:
            "Devka Beach is another famous coastal attraction near Vapi, attracting visitors with its expansive shoreline and refreshing sea breeze. The beach is popular for sightseeing, photography, and spending quality time with family and friends. During the evening hours, visitors can enjoy beautiful views of the Arabian Sea and vibrant sunsets."
    },
    {
        title: "Moti Daman Fort",
        description:
            "Moti Daman Fort is a magnificent Portuguese-era fort showcasing impressive architecture, historic churches, government buildings, and massive defensive walls. The fort offers visitors an opportunity to explore the rich colonial history of the region while enjoying scenic views and heritage structures preserved over centuries."
    },
    {
        title: "Dudhni Lake",
        description:
            "Dudhni Lake, located near the Gujarat-Dadra and Nagar Haveli border, is often referred to as the 'Mini Kashmir of the West.' The picturesque reservoir is surrounded by hills and lush greenery, offering boating, kayaking, water sports, and peaceful natural surroundings. It is one of the most scenic destinations accessible from Vapi."
    },
    {
        title: "Satmaliya Deer Park",
        description:
            "Satmaliya Deer Park is a wildlife attraction situated within Dadra and Nagar Haveli, where visitors can observe deer, antelope, peacocks, and various bird species in their natural habitat. The peaceful environment and rich biodiversity make it a favorite destination for families, nature enthusiasts, and wildlife photographers."
    },
    {
        title: "Vanganga Garden",
        description:
            "Vanganga Garden is a beautifully landscaped recreational park known for its lush greenery, decorative bridges, boating facilities, and serene lake. Visitors enjoy family outings, evening walks, photography, and relaxation amidst well-maintained gardens. The park is one of the most popular leisure destinations near Vapi."
    },
    {
        title: "Silvassa",
        description:
            "Silvassa, the capital of Dadra and Nagar Haveli, is located close to Vapi and is famous for its gardens, museums, tribal culture, resorts, and natural beauty. Visitors explore attractions such as Tribal Museum, Vanganga Lake Garden, and various eco-tourism destinations while experiencing the region's unique cultural heritage."
    },
    {
        title: "Dadra Garden",
        description:
            "Dadra Garden is a scenic destination featuring beautifully maintained landscapes, fountains, lakeside areas, and recreational facilities. Families and tourists visit the garden for picnics, boating, and outdoor activities while enjoying the peaceful surroundings and natural beauty of the area."
    },
    {
        title: "Industrial Hub of Vapi",
        description:
            "Vapi is one of India's largest industrial centers and an important destination for business travelers and corporate visitors. The city hosts numerous manufacturing units, chemical industries, pharmaceutical companies, and commercial establishments. Visitors traveling for business can conveniently combine their professional commitments with nearby sightseeing attractions, making a Mumbai to Vapi cab journey both productive and enjoyable."
    }
],



services: [
{
name: "Mumbai to Vapi Cab",
description: "Mumbai Airport Cab offers Mumbai to Vapi Cab service for comfortable, safe, and affordable travel between Mumbai and Vapi. Whether you are travelling for business meetings, industrial visits, corporate travel, factory inspections, family trips, tourism, or personal transportation, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickup services from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and surrounding locations, ensuring a reliable and hassle-free travel experience to Vapi."
},
{
name: "Mumbai to Vapi Taxi",
description: "Book Mumbai to Vapi Taxi with Mumbai Airport Cab for reliable and convenient transportation. Our experienced drivers, clean AC vehicles, affordable fares, and flexible pickup options make every journey comfortable for business travellers, families, and corporate clients."
},
{
name: "Mumbai to Vapi Taxi Fare",
description: "Get affordable Mumbai to Vapi Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, no hidden charges, multiple vehicle choices, and cost-effective travel packages for one way and round trip journeys."
},
{
name: "Mumbai to Vapi Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Vapi Cab Fare with professional chauffeurs, premium vehicles, dependable service, and flexible travel plans for all types of passengers."
},
{
name: "Cab from Mumbai to Vapi",
description: "Choose a Cab from Mumbai to Vapi with Mumbai Airport Cab and enjoy safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles."
},
{
name: "Mumbai to Vapi Car Rental",
description: "Book Mumbai to Vapi Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles for a flexible and comfortable travel experience."
},
{
name: "Mumbai to Vapi Cab Booking",
description: "Mumbai Airport Cab provides Mumbai to Vapi Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle options to suit every travel requirement."
},
{
name: "Mumbai to Vapi One Way Cab",
description: "Travel conveniently with Mumbai to Vapi One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Vapi Round Trip Cab",
description: "Mumbai Airport Cab offers Mumbai to Vapi Round Trip Cab packages for business visits, industrial tours, family travel, and corporate transportation with flexible travel schedules."
},
{
name: "Mumbai to Vapi Outstation Cab",
description: "Book Mumbai to Vapi Outstation Cab for comfortable long-distance travel with experienced drivers, premium vehicles, affordable rates, and customized travel packages."
},
{
name: "Mumbai to Vapi Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Vapi Taxi Service with safe transportation, clean AC vehicles, affordable fares, professional chauffeurs, and dependable customer support."
},
{
name: "Mumbai to Vapi Car Hire",
description: "Choose Mumbai to Vapi Car Hire with Mumbai Airport Cab for premium chauffeur-driven transportation featuring comfortable seating, flexible schedules, and personalized service."
},
{
name: "Mumbai to Vapi Industrial Travel Cab",
description: "Mumbai Airport Cab specializes in Mumbai to Vapi Industrial Travel Cab services for corporate employees, factory visits, industrial meetings, business executives, and commercial travel requirements."
},
{
name: "Mumbai Airport to Vapi Cab",
description: "Book Mumbai Airport to Vapi Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Vapi Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Vapi Cab service with doorstep pickup, affordable fares, reliable transportation, and premium vehicle options for business and leisure travellers."
},
{
name: "Thane to Vapi Cab",
description: "Choose Thane to Vapi Cab with Mumbai Airport Cab for reliable transportation, professional drivers, comfortable vehicles, and flexible travel schedules designed for a smooth journey."
},
{
name: "Mumbai to Vapi SUV Cab",
description: "Mumbai Airport Cab provides Mumbai to Vapi SUV Cab service for larger families, corporate teams, and groups seeking spacious interiors, premium comfort, and ample luggage space."
},
{
name: "Mumbai to Vapi Innova Cab",
description: "Book Mumbai to Vapi Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, professional chauffeur service, and reliable transportation ideal for families and business travellers."
}
],

tableData: [
["Mumbai to Vapi Cab","Mumbai to Vapi Taxi"],
["Mumbai to Vapi Taxi Fare","Mumbai to Vapi Cab Fare"],
["Cab from Mumbai to Vapi","Mumbai to Vapi Car Rental"],
["Mumbai to Vapi Cab Booking","Mumbai to Vapi One Way Cab"],
["Mumbai to Vapi Round Trip Cab","Mumbai to Vapi Outstation Cab"],
["Mumbai to Vapi Taxi Service","Mumbai to Vapi Car Hire"],
["Mumbai to Vapi Industrial Travel Cab","Mumbai Airport to Vapi Cab"],
["Navi Mumbai to Vapi Cab","Thane to Vapi Cab"],
["Mumbai to Vapi SUV Cab","Mumbai to Vapi Innova Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Vapi Cab Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Vapi Cab transportation for business travelers, industrial professionals, families, tourists, and corporate clients seeking comfortable travel."
},
{
WhyChooseheading: "Convenient Travel to Major Industrial Hub",
WhyChoosedescription: "Vapi is one of India's leading industrial cities, attracting business travelers, factory owners, professionals, and entrepreneurs from Mumbai."
},
{
WhyChooseheading: "Perfect for Corporate and Business Travel",
WhyChoosedescription: "Our cab service is widely preferred for factory visits, business meetings, industrial inspections, conferences, and official travel requirements."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel needs."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or customized itinerary, we offer flexible travel solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and surrounding areas."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced chauffeurs and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey."
},
{
WhyChooseheading: "Suitable for Business and Family Travel",
WhyChoosedescription: "From corporate travel and industrial visits to family trips and personal travel, we provide suitable transportation options for every requirement."
}
]
};

const faqData = [
{
question: "Why do travelers frequently book Mumbai to Vapi Cabs?",
answer: "Vapi is a major industrial and commercial city that attracts business travelers, factory professionals, entrepreneurs, and families throughout the year."
},
{
question: "Can I book a one-way cab from Mumbai to Vapi?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Vapi travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, and SUVs are among the most preferred options for comfortable intercity travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their business schedule and travel requirements."
},
{
question: "Can corporate travelers use this service regularly?",
answer: "Yes, many companies and professionals use Mumbai Airport Cabs for regular business meetings, factory visits, and industrial travel."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for corporate teams, family groups, and group transportation."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can multiple stops be included during the journey?",
answer: "Yes, customers can customize their itinerary and include industrial areas, business locations, restaurants, and personal stops."
},
{
question: "Is advance reservation recommended for Mumbai to Vapi travel?",
answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
},
{
question: "How can I book a Mumbai to Vapi Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Dhaval Shah",
feedback:
"For my regular business trips to Vapi, Mumbai Airport Cabs has always provided excellent service. The vehicles are comfortable, punctual, and professionally maintained.",
rating: 5
},
{
id: 2,
name: "Mrs. Rina Patel",
feedback:
"The entire travel experience was smooth and well organized. The driver was courteous, the cab was clean, and the journey was completed comfortably and on time.",
rating: 5
}
];





































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Vapi Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-vapi-cab.jpg",
"description": "Book Mumbai to Vapi cab service for safe, comfortable, and affordable intercity travel. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options between Mumbai and Vapi.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-vapi-cab"
}
};






    return (
        <div>




<Helmet>
  <title>Mumbai to Vapi Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Vapi cab service at affordable fares. Reliable taxi service with professional drivers, comfortable cars, and one-way and round-trip options for smooth intercity travel."
/>

<meta
 name="keywords"
 content="mumbai to vapi cab, mumbai to vapi taxi, mumbai to vapi taxi fare, mumbai to vapi cab fare, cab from mumbai to vapi, mumbai to vapi car rental, mumbai to vapi cab booking, mumbai to vapi one way cab, mumbai to vapi round trip cab, vapi taxi from mumbai, outstation cab mumbai to vapi, vapi cab service mumbai, affordable taxi mumbai to vapi, best cab service mumbai to vapi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/117.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitovapicab;